import { types } from "mobx-state-tree";
import { runInAction, makeAutoObservable } from "mobx";
// helpers
import StoreHelper from "src/base/helpers/store-helper";
// models
import { IOrderModel } from "src/models/order-model";
// apis
import OrderApi from "src/store/apis/order-api";

const checkoutState = {
  isCartFetching: true,
  paymentVerificationStep: 1,
  step: 1,
  order: StoreHelper.createOrderModel(),
};

const addressState = {
  isFetching: true,
  list: {},
};

class OrderStore {
  checkout = checkoutState;
  address = addressState;

  constructor() {
    makeAutoObservable(this);
  }

  resetState() {}

  resetCheckoutState() {
    runInAction(() =>
      Object.keys(checkoutState).forEach(
        (key) => (this.checkout[key] = checkoutState[key])
      )
    );
  }

  async fetchCarts(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      return await OrderApi.readCart(reqParams).then((response) => {
        runInAction(() => {
          this.checkout.isCartFetching = false;
        });

        if (response.success != 1) {
          return response.status;
        }

        let data = response.data;

        runInAction(() => {
          this.checkout.order.setCarts(data.carts);
        });

        if (data.carts.length <= 0) {
          window.location.href = "/";
        }

        return data;
      });
    } catch (e) {}
  }

  async fetchAddresses(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      return await OrderApi.readAddress(reqParams).then((response) => {
        runInAction(() => {
          this.address.isFetching = false;
          this.address.list = response.data;
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  async confirmCheckout(payload = null) {
    try {
      let _default = {};

      let reqParams = { ..._default, ...payload };

      return await OrderApi.checkout(reqParams).then((response) => {
        return response;
      });
    } catch (e) {
      console.log(e);
    }
  }
}

export default OrderStore;
